import React, { useEffect, useState, useRef } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import { SlIconButton, SlTooltip } from "@shoelace-style/shoelace/dist/react";

import { formatDate } from "../../utils/dateFormat";
import { roles } from "../../utils/constants";
import { CSVLink } from "react-csv";
import { formatDateDDMMYYY } from "../../utils/dateFormat";
import { Toast } from "../../shared/Toast";

function DateWise(props) {
  const navigate = useNavigate();
  const [completeData, setCompleteData] = useState([]);
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [tablePermissions, setTablePermissions] = useState(Array.isArray(props.permissions) ? props.permissions : []);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [downloadData, setDownloadData] = useState([]);
  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    setData(
      completeData.slice(
        event.selected * config.PER_PAGE,
        event.selected * config.PER_PAGE + config.PER_PAGE
      )
    );
  };

  const csvLinkRef = useRef();
  const Headers = [
    { label: "Date", key: "Date" },
    { label: "Impressions", key: "Impressions" },
    { label: "Clicks", key: "Clicks" },
    { label: "Spent", key: "Spent" },
  ];

  const getdata = async (page = 0) => {
    setLoader(true);
    try {
      let res = await api({
        url: "/order/orderwiseReports",
        method: "POST",
        responseType: "json",
        data: {
          order_id: props.order_id,
          action: "daywise",
        },
      });
      if (res.code === 200) {
        const entries = Object.entries(res.data?.totalres);
        setCompleteData(entries);
        setData(entries.slice(0, config.PER_PAGE));
        setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
        setDownloadData(entries.map(([_, value]) => value));
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  const downloadReport = () => {
    // if (localStorage.getItem("role") !== roles.financer) return;
    if (!downloadData || downloadData.length === 0) {
      Toast("info", "No Data Available");
      return;
    }
    setDownloadLoader(true);
    csvLinkRef?.current?.link?.click();
    setTimeout(() => {
      setDownloadLoader(false);
    }, 1000);
  };
  useEffect(() => {
    getdata();
  }, []);

  return (
    <div>
      <div className="overflow-x-auto mb-4">
        <div className="flex justify-end items-center m-4">
          <CSVLink
            data={downloadData.map(
              ({ date, adv_total_imp, adv_total_click, total_spent }) => ({
                Date: formatDateDDMMYYY(date),
                Impressions: adv_total_imp,
                Clicks: adv_total_click,
                Spent: total_spent,
              })
            )}
            headers={Headers}
            filename="report.csv"
            ref={csvLinkRef}
            className="hidden"
          />
          {downloadLoader ? (
            <TableLoader />
          ) : (
            <SlTooltip content="Download LineItem DateWiseReports">
              <SlIconButton
                library="lucide"
                name="download"
                onClick={downloadReport}
              />
            </SlTooltip>
          )}
        </div>
        <table className="table table-bordered">
          <thead>
            <tr>
              {/* Campaign Creation */}
              {/* <th scope="col">Campaign Id</th> */}
              <th scope="col">Date</th>
              {localStorage.getItem("role") === roles.ops && (
                <th scope="col">Adv Impressions</th>
              )}
              {localStorage.getItem("role") === roles.ops && (
                <th scope="col">Adv Clicks</th>
              )}
              {localStorage.getItem("role") === roles.ops && (
                <th scope="col">Adv CTR(%)</th>
              )}
              {localStorage.getItem("role") === roles.ops && (
                <th scope="col">Adv ECPM</th>
              )}
              {localStorage.getItem("role") === roles.advertiser &&
              tablePermissions.includes("impressions") ? (
                <th>Audience Viewed</th>
              ) : localStorage.getItem("role") === roles.salesperson &&
                tablePermissions.includes("impressions") ? (
                <th scope="col">Impressions</th>
              ) : localStorage.getItem("role") !== roles.advertiser &&
                localStorage.getItem("role") !== roles.salesperson ? (
                <th scope="col">Impressions</th>
              ) : null}

              {localStorage.getItem("role") === roles.advertiser &&
              tablePermissions.includes("clicks") ? (
                <th>Audience Engaged</th>
              ) : localStorage.getItem("role") === roles.salesperson &&
                tablePermissions.includes("clicks") ? (
                <th scope="col">Clicks</th>
              ) : localStorage.getItem("role") !== roles.advertiser &&
                localStorage.getItem("role") !== roles.salesperson ? (
                <th scope="col">Clicks</th>
              ) : null}
              {localStorage.getItem("role") === roles.ops && (
                <th scope="col">CTR(%)</th>
              )}
              {localStorage.getItem("role") === roles.ops && (
                <th scope="col">ECPM</th>
              )}
              {localStorage.getItem("role") === roles.ops && (
                <th scope="col">Advertiser Spent</th>
              )}
              {(localStorage.getItem("role") === roles.advertiser &&
                tablePermissions.includes("spent")) ||
              (localStorage.getItem("role") === roles.salesperson &&
                tablePermissions.includes("spent")) ? (
                <th scope="col">Spent</th>
              ) : localStorage.getItem("role") !== roles.advertiser &&
                localStorage.getItem("role") !== roles.salesperson ? (
                <th scope="col">Spent</th>
              ) : null}
              {localStorage.getItem("role") === roles.ops && <th>Shares</th>}
            </tr>
          </thead>
          {data?.length && !loader ? (
            <tbody>
              {data?.map((item, index) => {
                return (
                  <tr key={item[1].date}>
                    <td>{formatDate(item[1].date)}</td>
                    {localStorage.getItem("role") === roles.ops && (
                      <td>{parseInt(item[1].adv_total_imp)}</td>
                    )}
                    {localStorage.getItem("role") === roles.ops && (
                      <td>{parseInt(item[1].adv_total_click)}</td>
                    )}
                    {localStorage.getItem("role") === roles.ops && (
                      <td>
                        {item &&
                        item[1]?.adv_total_click > 0 &&
                        item[1]?.adv_total_imp > 0
                          ? (
                              (item[1].adv_total_click /
                                item[1].adv_total_imp) *
                              100
                            ).toFixed(2)
                          : 0}
                      </td>
                    )}
                    {localStorage.getItem("role") === roles.ops && (
                      <td>
                        {item
                          ? (
                              (item[1]?.adv_spent / item[1]?.adv_total_imp) *
                              1000
                            ).toFixed(2)
                          : 0}
                      </td>
                    )}
                    {localStorage.getItem("role") === roles.ops ? (
                      <td> {parseInt(item[1].total_imp)} </td>
                    ) : // : parseInt(item[1].adv_total_imp)}
                    (localStorage.getItem("role") === roles.advertiser &&
                        tablePermissions.includes("impressions")) ||
                      (localStorage.getItem("role") === roles.salesperson &&
                        tablePermissions.includes("impressions")) ||
                      localStorage.getItem("role") === roles.financer ||
                      localStorage.getItem("role") === roles.vendor_admin ? (
                      <td>{parseInt(item[1]?.adv_total_imp)}</td>
                    ) : null}

                    {localStorage.getItem("role") === roles.ops ? (
                      <td>{parseInt(item[1].total_click)}</td>
                    ) : // : parseInt(item[1].adv_total_click)
                    (localStorage.getItem("role") === roles.advertiser &&
                        tablePermissions.includes("clicks")) ||
                      (localStorage.getItem("role") === roles.salesperson &&
                        tablePermissions.includes("clicks")) ||
                      localStorage.getItem("role") === roles.financer ||
                      localStorage.getItem("role") === roles.vendor_admin ? (
                      <td>{parseInt(item[1].adv_total_click)}</td>
                    ) : null}

                    {localStorage.getItem("role") === roles.ops && (
                      <td>
                        {item[1].total_click > 0 && item[1].total_imp > 0
                          ? (
                              (item[1].total_click / item[1].total_imp) *
                              100
                            ).toFixed(2)
                          : 0}
                      </td>
                    )}
                    {localStorage.getItem("role") === roles.ops && (
                      <td>
                        {item
                          ? (
                              (item[1]?.total_spent / item[1]?.total_imp) *
                              1000
                            ).toFixed(2)
                          : 0}
                      </td>
                    )}
                    {localStorage.getItem("role") === roles.ops && (
                      <td>{item[1].adv_spent.toFixed(2)}</td>
                    )}
                    {(localStorage.getItem("role") === roles.advertiser ||
                      localStorage.getItem("role") === roles.salesperson) &&
                    tablePermissions.includes("spent") ? (
                      <td>{item[1].total_spent.toFixed(2)}</td>
                    ) : localStorage.getItem("role") === roles.ops ||
                      localStorage.getItem("role") === roles.financer ||
                      localStorage.getItem("role") === roles.vendor_admin ? (
                      <td>{item[1].total_spent.toFixed(2)}</td>
                    ) : null}
                    {localStorage.getItem("role") === roles.ops && (
                      <td className="p-2">
                        {parseInt(item[1]?.shares > 0 ? item[1]?.shares : 0)}
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          ) : !data?.length && !loader ? (
            <NoDataFound colspan="15" />
          ) : (
            <TableLoader colspan="15" />
          )}
        </table>
      </div>
      <div>
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage}
          />
        )}
      </div>
    </div>
  );
}

export default DateWise;
